export default __webpack_public_path__ + "static/media/dongle_leg.96f3047d.gif";